import Header from '../components/header.js';
import WhiteThinLine from '../components/line.js';
import CheckIsMobile from '../components/mobile.js';

export default function Services()
{
    let isMobile = CheckIsMobile();

    const H1Style = {
        textAlign: "center",
        display:"flex", 
        paddingTop: isMobile ? "1.5rem" : "2.5rem", 
        paddingBottom: isMobile ? "1.5rem" : "2.5rem", 
        justifyContent:"center", 
        alignContent:"center", 
        padding: "20px", 
        color:"cyan"
    }

    let ThickCyanLineStyle = {
        borderWidth: "1.5px", 
        borderColor: "cyan", 
        width: isMobile ? "80%" : "50%",    
        marginLeft: "auto", 
        marginRight: "auto"
    }

    let ParagraphStyle = {
        lineHeight: 1.8, 
        color: "white", 
        fontSize: isMobile ? "1.3rem" : "1.5rem", 
        paddingLeft: isMobile ? 50 : 75,
        paddingRight: isMobile ? 35 : 40, 
        font: "large", 
        alignItems: "center", 
        justifyContent: "center"
    }

    let ImageStyle = { 
        backgroundImage: `url('https://amvco.com.au/wp-content/uploads/2021/05/services-hero-1400x800-2880w.jpg')`, 
        width: "100%", 
        height: isMobile ? "70vh" : "100vh",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat"
    }

    return (
        <div>
            <Header />

            <section style={ ImageStyle } />

            <section style={ H1Style }>
                <h1 style={{ fontSize: isMobile ? "1.5rem" : "2.5rem" }}>Machine Vision System Integration</h1>
            </section>
            <hr style={ ThickCyanLineStyle } />
            
            <br />
            <section style={ ParagraphStyle }>
                <p>Australian Machine Vision delivers customised and reliable solutions for demanding inspection and process control applications.</p>
                <p>We take the time to understand your specific requirements and translate these into machine vision deliverables.</p> 
                <p>Our package of technology and services can be tailored to suit your individual circumstances.</p> 
            </section> <br />
            
            <WhiteThinLine />
            
            <section style={ H1Style }>
                <h1 style={{ fontSize: isMobile ? "1.5rem" : "2.5rem" }}>Our Services</h1>
            </section>
            <hr style={{ borderWidth: "1.5px", borderColor: "cyan", width: isMobile ? "35%" : "23%",
                        marginLeft: "auto", marginRight: "auto" }} />
            
            <div style={{display: "flex", justifyContent: "space-between", maxWidth: "1200px",
                         margin: "20px auto", padding: "20px", background: "black", color: "white",
                         height: "auto", flexDirection: isMobile ? "column" : "row"}}>
                <div style={{width: isMobile ? "100%" : "48%", padding: "0 25px"}}>
                    <h2 style={{lineHeight: 1.5, color: "cyan", fontSize: isMobile ? "25px" : "30px", paddingLeft: "25px", paddingRight: isMobile ? "50px" : "0px" }}>System Integration</h2>
                    <br />
                    <p style={{paddingLeft: "25px", color: "white", lineHeight: "1.8", fontSize: isMobile ? "1.2rem" : "1.3rem"}}>
                        As an independent system integrator, we're able to choose any machine
                        vision software and hardware for a particular application. Therefore,
                        we can provide you with a solution to match your requirements. We
                        provide both off-the-shelf machine vision systems and customised
                        solutions to ensure we can meet your needs.
                    </p>
                </div> <br />

                <div style={{width: isMobile ? "100%" : "48%", padding: "0 25px"}}>
                    <h2 style={{lineHeight: 1.5, color: "cyan", fontSize: isMobile ? "25px" : "30px", paddingLeft: "25px", paddingRight: isMobile ? "30px" : "0px"}}>Custom Solutions</h2>
                    <br />
                    <p style={{ paddingLeft: "25px", paddingRight: isMobile ? "15px" : "0px", color: "white", lineHeight: "1.8", fontSize: isMobile ? "1.2rem" : "1.3rem"}}>
                        Australian Machine Vision has the technical capability to apply our
                        extensive machine vision experience to many applications and
                        requirements across all industry sectors. These include the
                        automotive, medical, construction materials, energy, and many other
                        industries.
                    </p>
                </div>
            </div>
            
            <WhiteThinLine />

            <section style={ H1Style }>
                <h1 style={{ fontSize: isMobile ? "1.8rem" : "2.2rem", textAlign: 'center' }}>Get in touch with our team today  by calling 0418 535 729 </h1> 
                <h1 style={{ fontSize:"1.875rem" }}> <br /></h1>
            </section>

            <br/> <hr style={{ borderWidth: "1.5px", borderColor: "white", width: "90%",          
                               marginLeft: "auto", marginRight: "auto", marginTop: "1rem" }} />

            <br /> <br /> <br /> <br/>
        </div>
    );
}
